<template>
  <div class="content" id="tableBox" ref="tableBox">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="buildManage">
        <span slot="label">
          <i class="border"></i> 楼宇信息管理
        </span>
        <div class="btnGroup">
          <button v-if="selectedNode && selectedNode.data.type == 1" class="Green" @click="addBuildingInfo">新增楼宇信息</button>
        </div>
        <div class="tabContent">
          <div class="areaTree">
            <el-tree ref="tree" node-key="label" :data="treeData" :props="defaultProps" :expand-on-click-node="false" :default-expand-all="false" :render-after-expand="true" lazy :load="loadNode"
              @node-click="handleAreaNodeClick">
              <div class="tree_node" slot-scope="{ data }">
                <i :class="data.type === 1 ? 'leaf_dot' : ''"></i>
                <span>{{ data.name }}</span>
              </div>
            </el-tree>
          </div>
          <div class="buildInfo">
            <div class="titleTop">
              <span>楼宇信息管理</span>
            </div>
            <div class="btnCon" v-if="buildingData.length > 0">
              <button class="Green" @click.stop="addBuilding" v-if="selectBuilding && selectBuilding.type != 1">新增下级建筑</button>
            </div>
            <div class="buildTree" v-if="buildingData.length > 0
            ">
              <el-tree :data="buildingData" :props="defaultProp" node-key="id" default-expand-all :expand-on-click-node="false" @node-click="handleBuildingClick">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <i :class="data.type === 1 ? 'leaf_dot' : ''"></i>
                  <span>{{ node.label }}</span>
                  <span style="margin-left: 10px;" v-if="data.id != 0">
                    <el-button type="text" size="mini" @click.stop="()=> edit(node, data)">
                      编辑
                    </el-button>
                    <el-button type="text" size="mini" @click.stop="() => remove(node, data)">
                      删除
                    </el-button>
                  </span>
                </span>
              </el-tree>
            </div>
          </div>
          <div class="facilitiesInfo">
            <div class="titleTop">
              <span>消防设施配置</span>
            </div>
            <div class="btnCon">
              <button class="Green" @click="addFacilities" v-if="selectBuilding && selectBuilding.type == 1">新 增</button>
            </div>
            <div style="margin: 30px;">
              <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
                <el-table-column label="消防设施" prop="maintenanceContentName"></el-table-column>
                <el-table-column label="数量" prop="number"></el-table-column>
                <el-table-column label="操作" width="230">
                  <template slot-scope="scope">
                    <el-link icon="iconfont iconedit" type="text" size="small" @click="editFacilities(scope.row)">编辑</el-link>
                    <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteFacilities(scope.row)">删除</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <building-dialog v-model="buildingModel" :status="buildingStatus" :data="buildingDetail" @refresh="getBuildingInfo(selectedNode.data.id)" :selectBuilding="selectBuilding"
        :selectedNode="selectedNode">
      </building-dialog>
      <facilities-dialog v-model="facilitiesModel" :status="facilitiesStatus" :data="facilitiesDetail" @refresh="getFacilitiesInfo(selectBuilding.id)" :selectBuilding="selectBuilding">
      </facilities-dialog>
    </el-tabs>
  </div>
</template>

<script>
import buildingDialog from './buildingDialog'
import facilitiesDialog from './facilitiesDialog'
export default {
  name: 'buildManage',
  components: {
    facilitiesDialog,
    buildingDialog
  },
  data() {
    return {
      tabName: 'buildManage',
      defaultProps: {
        label: 'name',
        isLeaf: 'isLeaf'
      },
      // 区域树数据
      treeData: [],
      // 展开区域树数据
      expandTreeData: [],
      // 用户权限区域节点
      filterNodeData: [],
      selectedNode: undefined,
      buildingData: [],
      defaultProp: {
        label: 'name',
        children: 'areaBuildings'
      },
      selectBuilding: undefined,
      tableData: [],
      buildingModel: false,
      buildingDetail: {},
      buildingStatus: 'adding',
      facilitiesModel: false,
      facilitiesStatus: '',
      facilitiesDetail: {}
    }
  },
  methods: {
    initTreeData() {
      let p1 = this.$axiosget('operation/area/queryAll?ignoreCache=true')
      let that = this
      Promise.resolve()
        .then(() => {
          p1.then((res1) => {
            res1 = res1.data.data || []
            if (res1 && res1.length) {
              let allData = []
              let tempData = res1
              while (tempData && tempData.length) {
                let tempArray = []
                tempData.forEach((td) => {
                  if (td.areas) {
                    tempArray = tempArray.concat(td.areas)
                  }
                  // 去除无关属性
                  let {
                    id,
                    parentId,
                    name,
                    address,
                    type,
                    model,
                    level,
                    danger,
                    longitude,
                    latitude,
                    url,
                    areaParameter,
                    mapNumber,
                    floorNumber,
                    dotNumber
                  } = td
                  td = {
                    id,
                    parentId,
                    name,
                    address,
                    type,
                    model,
                    level,
                    danger,
                    longitude,
                    latitude,
                    url,
                    areaParameter,
                    mapNumber,
                    floorNumber,
                    dotNumber
                  }
                  allData.push(td)
                })
                tempData = tempArray
              }
              this.expandTreeData = allData
              this.treeData = res1
            }
          })
        })
        .then(() => {
          if (that.userAreaList && that.userAreaList.length) {
            that.filterNodeData = that.userAreaList
            return
          }
          let p2 = this.$axiosget('operation/area/findAreaByUserId')
          p2.then((res2) => {
            res2 = res2.data.data || []
            if (res2 && res2.length) {
              that.filterNodeData = that.filterNodeData.concat(res2)
              that.$store.commit('SET_USER_AREA', res2)
            }
          })
        })
    },
    loadNode(node, resolve) {
      let nextList =
        this.expandTreeData.filter((it) => it.parentId === node.data.id) || []
      nextList.forEach((it) =>
        Object.assign(it, {
          isLeaf:
            it.type === 1 ||
            !this.expandTreeData.some((t) => t.parentId === it.id)
        })
      )
      resolve(nextList)
    },
    handleAreaNodeClick(data, node, self) {
      this.selectBuilding = undefined
      if (data.type == 1) {
        this.selectedNode = node
        this.getBuildingInfo(this.selectedNode.data.id)
      } else {
        this.selectedNode = undefined
        this.buildingData = []
        this.tableData = []
      }
    },
    addBuildingInfo() {
      if (this.selectedNode) {
        this.buildingStatus = 'adding'
        this.buildingTitle = '新增'
        this.buildingDetail = {}
        this.buildingModel = true
      } else {
        this.$message.warning('请先选择节点！')
      }
    },
    getBuildingInfo(value) {
      this.$axiosget('extra/areaBuilding', {
        params: {
          id: value
        }
      }).then((res) => {
        this.buildingData = res.data.data
      })
    },
    handleBuildingClick(data, node) {
      this.selectBuilding = data
      this.getFacilitiesInfo(data.id)
    },
    addBuilding() {
      this.buildingStatus = 'adding'
      this.buildingTitle = '新增楼宇信息'
      this.buildingDetail = {}
      this.buildingModel = true
    },
    edit(node, data) {
      let cloneData = _.cloneDeep(data)
      this.buildingDetail = cloneData
      this.buildingStatus = 'editing'
      this.buildingTitle = '编辑楼宇信息'
      this.buildingModel = true
    },
    remove(node, data) {
      this.$confirm('确定删除该楼宇设施吗?', '', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        confirmButtonClass: 'confirmButton',
        cancelButtonClass: 'cancelButton',
        type: 'warning'
      }).then(() => {
        this.$axiosdelete('extra/areaBuilding', {
          params: {
            id: data.id
          }
        }).then((res) => {
          if (res.data.status == 10000) {
            this.$message.success('删除成功')
            this.getBuildingInfo(this.selectedNode.data.id)
          }
        })
      })
    },
    getFacilitiesInfo(value) {
      this.$axiosget('extra/areaBuildingFacility', {
        params: {
          id: value
        }
      }).then((res) => {
        if (res.data.status == 10000) {
          this.tableData = res.data.data
        }
      })
    },
    addFacilities() {
      this.facilitiesStatus = 'adding'
      this.facilitiesTitle = '新增消防设施'
      this.facilitiesDetail = {}
      this.facilitiesModel = true
    },
    editFacilities(row) {
      let cloneData = _.cloneDeep(row)
      this.facilitiesDetail = cloneData
      this.facilitiesStatus = 'editing'
      this.facilitiesModel = true
    },
    deleteFacilities(row) {
      this.$confirm('删除该消防设施吗?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosdelete('extra/areaBuildingFacility', {
          params: {
            id: row.id
          }
        }).then((res) => {
          if (res.data.status == 10000) {
            this.getFacilitiesInfo(this.selectBuilding.id)
            this.$message.success('删除成功!')
          }
        })
      })
    }
  },
  created() {
    this.initTreeData()
  }
}
</script>

<style lang="less" scoped>
.content {
  .tabContent {
    width: 100%;
    height: auto;
    min-height: 800px;
    display: flex;
    flex-flow: row nowrap;
    background-color: rgba(0, 0, 0, 0.2);

    .areaTree {
      width: 320px;
      height: 800px;
      overflow-y: auto;
      background: #181c2e;
      padding: 10px;

      .el-tree {
        background: transparent;
        color: #ccc;
        font-size: 14px;

        /deep/ .el-tree-node,
        .el-tree-node:focus {
          background: transparent;

          .el-tree-node__content {
            background: transparent;
            height: 40px;
            line-height: 40px;
            padding-left: 18px;
            border-bottom: 1px solid #182252;

            .el-tree-node__label {
              background: transparent;
              width: 100%;
              height: 40px;
              line-height: 40px;
            }
          }
          .el-tree-node__content:hover,
          .el-tree-node__content:focus {
            background: #212740 !important;
            border-bottom: 1px solid #0e69b0 !important;
          }
        }

        /deep/ .el-tree-node.is-current,
        .el-tree-node.is-expanded {
          > .el-tree-node__content {
            background: #212740 !important;
            border-bottom: 1px solid #0e69b0 !important;
          }
        }

        .tree_node {
          display: block;
          padding: 0 10px;

          i {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 2px;
            margin: 0 4px;
            background: #0e69b0;
            vertical-align: middle;
            box-shadow: 0 1px 2px 2px #000;
          }

          i.leaf_dot {
            border-radius: 5px;
            background: #6a7893;
            box-shadow: inset 0 0 0 3px #000;
          }

          span {
            display: inline-block;
            width: auto;
            line-height: 30px;
            font-size: 13px;
          }

          a {
            color: #00a3c6;
            font-size: 12px;
            margin: 0 10px;
          }
        }
      }
    }
    .buildInfo {
      width: 390px;
      margin: 0 30px;
      height: auto;
      min-height: 800px;
      background: #181c2e;

      .buildTree {
        padding: 10px;

        .el-tree {
          background: transparent;
          color: #ccc;
          font-size: 14px;

          /deep/ .el-tree-node,
          .el-tree-node:focus {
            background: transparent;

            .el-tree-node__content {
              background: transparent;
              height: 40px;
              line-height: 40px;
              padding-left: 18px;
              border-bottom: 1px solid #182252;

              .el-tree-node__label {
                background: transparent;
                width: 100%;
                height: 40px;
                line-height: 40px;
              }
            }
            .el-tree-node__content:hover,
            .el-tree-node__content:focus {
              background: #212740 !important;
              border-bottom: 1px solid #0e69b0 !important;
            }
          }

          /deep/ .el-tree-node.is-current,
          .el-tree-node.is-expanded {
            > .el-tree-node__content {
              background: #212740 !important;
              border-bottom: 1px solid #0e69b0 !important;
            }
          }

          .custom-tree-node {
            display: block;
            padding: 0 10px;

            i {
              display: inline-block;
              width: 10px;
              height: 10px;
              border-radius: 2px;
              margin: 0 4px;
              background: #0e69b0;
              vertical-align: middle;
              box-shadow: 0 1px 2px 2px #000;
            }

            i.leaf_dot {
              border-radius: 5px;
              background: #6a7893;
              box-shadow: inset 0 0 0 3px #000;
            }
          }
        }
      }
    }

    .facilitiesInfo {
      width: calc(100% - 760px);
      height: auto;
      min-height: 800px;
      background: #181c2e;
    }

    .titleTop {
      height: 52px;
      line-height: 50.5px;
      border-bottom: 1px solid rgb(33, 76, 113);

      span {
        display: inline-block;
        padding: 0 20px;
        font-size: 14px;
        color: #fff;
        border-bottom: 1px solid #8553e7;
      }
    }

    .btnCon {
      width: auto;
      height: 52px;
      line-height: 52px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 30px 20px;
      display: flex;
      justify-content: flex-end;

      .Green {
        width: auto;
        min-width: 80px;
        max-width: 120px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        margin: 0 5px;
        outline: 0;
        border: 0 none;
        -webkit-appearance: none;
        -webkit-transition: 0.1s;
        transition: 0.1s;
        border-radius: 2px;
        white-space: normal;
        cursor: pointer;
        padding: 0 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/buildingManage/buildManage/index.vue